// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { CompleteResetAuthPasswordResetCompletePostMutationRequest, CompleteResetAuthPasswordResetCompletePostMutationResponse, CompleteResetAuthPasswordResetCompletePost400, CompleteResetAuthPasswordResetCompletePost410, CompleteResetAuthPasswordResetCompletePost422 } from "../models/emailAuthController/CompleteResetAuthPasswordResetCompletePost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getCompleteResetAuthPasswordResetCompletePostUrl() {
  const res = { method: 'POST', url: `/auth/password/reset/complete` as const }
  return res
}

/**
 * @description Complete password reset.
 * Verifies code and sets new password.
 * @summary Complete Reset
 * {@link /auth/password/reset/complete}
 */
export async function completeResetAuthPasswordResetCompletePost(data: CompleteResetAuthPasswordResetCompletePostMutationRequest, config: Partial<RequestConfig<CompleteResetAuthPasswordResetCompletePostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CompleteResetAuthPasswordResetCompletePostMutationResponse, ResponseErrorConfig<CompleteResetAuthPasswordResetCompletePost400 | CompleteResetAuthPasswordResetCompletePost410 | CompleteResetAuthPasswordResetCompletePost422>, CompleteResetAuthPasswordResetCompletePostMutationRequest>({ method : "POST", url : getCompleteResetAuthPasswordResetCompletePostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}